/* eslint-disable import/no-unresolved */
import { MatxLoadable } from "matx";

const ListTasks = MatxLoadable({
  loader: () => import("../views/task"),
});

const TaskNew = MatxLoadable({
  loader: () => import("../views/task/newTask"),
});

const TaskMapLoad = MatxLoadable({
  loader: () => import("../views/task/taskMap"),
});

const taskRoutes = [
  {
    path: "/task/list",
    component: ListTasks,
    permission: ["manager", "account_holder", "customer_service"],
  },
  {
    path: "/task/task_map",
    component: TaskMapLoad,
    permission: ["manager", "account_holder", "customer_service"],
  },
  {
    path:
      "/task/new_task/:vehicleId/:name/:plate/:startTime/:endTime/:serResId",
    component: TaskNew,
    permission: ["manager", "account_holder", "customer_service"],
  },
  {
    path: "/task/new_task/:valetId",
    component: TaskNew,
    permission: ["manager", "account_holder", "customer_service"],
  },
  {
    path: "/task/new_task",
    component: TaskNew,
    permission: ["manager", "account_holder", "customer_service"],
  },
];

export default taskRoutes;
